/**
 * Dracula Edition offer card — the "View details" sheet on each piece row (owner 2026-09-14: "click vào thì popup ra
 * thông tin chi tiết từng sản phẩm"). Ported from Afroyla's afroyla-sunday-set-sheet.js.
 *
 * Every row in snippets/lettoria-edition-offer-box.liquid carries [data-ltr-sheet-view="n"] (the thumb and the link)
 * and a <template data-ltr-sheet="n"> that Liquid already filled with the sheet BODY (photos, eyebrow, name, note,
 * why list, details, quote). This file only owns the shell: overlay + sheet + close + a mirror of the card's own CTA
 * ([data-ltr-ed-cta]) so the cart logic stays in lettoria-edition-offer.js. Shell classes = lettoria-edition-sheet.css.
 */
(function () {
  'use strict';

  if (window.__ltrEdSheetInit) return;
  window.__ltrEdSheetInit = true;

  var overlay = null;
  var sheet = null;
  var lastFocus = null;

  function closeSheet() {
    if (!sheet) return;
    var s = sheet;
    var o = overlay;
    sheet = overlay = null;
    s.classList.remove('is-open');
    o.classList.remove('is-open');
    document.documentElement.classList.remove('ltr-sheet-lock');
    window.setTimeout(function () {
      s.remove();
      o.remove();
    }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openSheet(box, tpl, name) {
    closeSheet();
    overlay = document.createElement('div');
    overlay.className = 'ltr-sheet-overlay';
    sheet = document.createElement('div');
    sheet.className = 'ltr-sheet';
    sheet.setAttribute('data-hc-section', 'modal'); // HC Pixel role: clicks inside report as modal
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', name);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ltr-sheet__close';
    close.setAttribute('aria-label', 'Close');
    close.setAttribute('data-hc-el', 'x-quick-view-close');
    close.textContent = '×';
    sheet.appendChild(close);
    sheet.appendChild(tpl.content.cloneNode(true));

    var body = sheet.querySelector('.ltr-sheet__body');
    var foot = document.createElement('div');
    foot.className = 'ltr-sheet__foot';
    // mirror of the card CTA: a convinced reader adds both pieces from inside the sheet instead of scrolling back
    var cta = box.querySelector('[data-ltr-ed-cta]');
    if (cta && !cta.disabled) {
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'ltr-sheet__btn ltr-sheet__btn--add';
      add.setAttribute('data-hc-el', 'quick-view-add');
      var label = cta.querySelector('[data-ltr-ed-label]');
      var price = cta.querySelector('.ltr-ed-cta__price [data-ltr-ed-price]');
      add.textContent = (label ? label.textContent : cta.textContent).trim() + (price ? ' — ' + price.textContent.trim() : '');
      add.addEventListener('click', function () {
        closeSheet();
        if (box.__ltrEd && typeof box.__ltrEd.add === 'function') box.__ltrEd.add(); else cta.click();
      });
      foot.appendChild(add);
    }
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'ltr-sheet__btn ltr-sheet__btn--ghost';
    back.setAttribute('data-hc-el', 'x-quick-view-close');
    back.textContent = tpl.getAttribute('data-back') || 'Back to the set';
    foot.appendChild(back);
    (body || sheet).appendChild(foot);

    document.body.appendChild(overlay);
    document.body.appendChild(sheet);
    document.documentElement.classList.add('ltr-sheet-lock');
    overlay.addEventListener('click', closeSheet);
    close.addEventListener('click', closeSheet);
    back.addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (event) {
      var thumb = event.target.closest('.ltr-sheet__thumb');
      if (!thumb) return;
      sheet.querySelector('.ltr-sheet__hero').src = thumb.getAttribute('data-big');
      sheet.querySelectorAll('.ltr-sheet__thumb').forEach(function (other) {
        other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
      });
    });
    window.requestAnimationFrame(function () {
      if (!sheet) return;
      overlay.classList.add('is-open');
      sheet.classList.add('is-open');
      close.focus();
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var view = event.target.closest('[data-ltr-sheet-view]');
    if (!view) return;
    // a trigger outside the offer box (the details band) falls back to the fold's box, where the templates live
    var box = view.closest('[data-ltr-ed]') || document.querySelector('[data-ltr-ed]');
    var tpl = box && box.querySelector('template[data-ltr-sheet="' + view.getAttribute('data-ltr-sheet-view') + '"]');
    if (!tpl) return;
    event.preventDefault();
    lastFocus = view;
    openSheet(box, tpl, view.getAttribute('aria-label') || 'Details');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && sheet) closeSheet();
  });
})();
